import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-[#0F172A] to-[#020617] text-white mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1">
            <div className="mb-4">
              <img 
                src="/munro-logo.png" 
                alt="MUNRO - Power Transmission Belts" 
                className="h-24 w-auto"
              />
            </div>
            <p className="text-gray-400 text-sm">
              Leading manufacturer and supplier of Power Transmission Belts and Industrial Belting Solutions since 1951.
            </p>
          </div>

          <div>
            <h3 className="font-bold text-white text-sm mb-4 tracking-wider">QUICK LINKS</h3>
            <ul className="space-y-2">
              <li><Link to="/configure" className="text-gray-400 hover:text-[#60A5FA] text-sm transition-colors">Request Quotation</Link></li>
              <li><Link to="/selection-guide" className="text-gray-400 hover:text-[#60A5FA] text-sm transition-colors">Selection Guide</Link></li>
              <li><Link to="/applications" className="text-gray-400 hover:text-[#60A5FA] text-sm transition-colors">Applications</Link></li>
              <li><Link to="/certifications" className="text-gray-400 hover:text-[#60A5FA] text-sm transition-colors">Certifications</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-white text-sm mb-4 tracking-wider">PRODUCTS</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/products?category=conveyor-belts" className="text-gray-400 hover:text-[#60A5FA] transition-colors">Conveyor Belts</Link></li>
              <li><Link to="/products?category=heavy-duty-v-belts" className="text-gray-400 hover:text-[#60A5FA] transition-colors">V-Belts</Link></li>
              <li><Link to="/products?category=caterpillar-belts" className="text-gray-400 hover:text-[#60A5FA] transition-colors">Caterpillar Belts</Link></li>
              <li><Link to="/products?category=take-up-drive-belts" className="text-gray-400 hover:text-[#60A5FA] transition-colors">Take Up Drive Belts</Link></li>
              <li><Link to="/products?category=wedge-belts" className="text-gray-400 hover:text-[#60A5FA] transition-colors">Wedge Belts</Link></li>
              <li><Link to="/products?category=food-grade-belts" className="text-gray-400 hover:text-[#60A5FA] transition-colors">Food Grade Belts</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-white text-sm mb-4 tracking-wider">CONTACT</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 text-sm text-gray-400">
                <Mail size={16} className="text-[#60A5FA]" />
                <span>sales@simpsonmunro.in</span>
              </li>
              <li className="flex items-center space-x-2 text-sm text-gray-400">
                <Mail size={16} className="text-[#60A5FA]" />
                <span>simpsmunro@gmail.com</span>
              </li>
              <li className="flex items-center space-x-2 text-sm text-gray-400">
                <Phone size={16} className="text-[#60A5FA]" />
                <span>+91 33 2248 1686</span>
              </li>
              <li className="flex items-start space-x-2 text-sm text-gray-400">
                <MapPin size={16} className="text-[#60A5FA] mt-1 flex-shrink-0" />
                <span>4 Lyons Range, Kolkata 700001, West Bengal, India</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm text-center md:text-left">
              © 2024 MUNRO® - SIMPSON & MUNRO (INDIA) PVT LTD. All rights reserved. | munrobeltings.com
            </p>
            <div className="flex gap-6 text-sm">
              <Link to="/privacy-policy" className="text-gray-400 hover:text-[#60A5FA] transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms-of-use" className="text-gray-400 hover:text-[#60A5FA] transition-colors">
                Terms of Use
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;